import { Component } from "react";
import Dropdown from "./../Dropdown/Dropdown";
import { getLanguages } from "./../../services/config";
import * as _ from "underscore";

const DEFAULT_OPTION = "Select a language";

export default class NativeLanguageSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value || DEFAULT_OPTION,
      languages: [],
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    const _this = this;
    getLanguages(
      undefined,
      resp => {
        _this.setState({ languages: resp });
      },
      () => {
        // TODO ?
      }
    );
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.value !== this.props.value) {
      nextState.value = nextProps.value || DEFAULT_OPTION;
    }
  }

  onChange(evt) {
    const value = evt.target.value;
    const obj = _.findWhere(this.state.languages, { code: value });
    this.props.onChange && this.props.onChange(obj);
    this.setState({ value: value });
  }

  render() {
    const options = this.state.languages.map((lang, i) => (
      <option key={i} value={lang.code}>
        {lang.native_name + " (" + lang.english_name + ")"}
      </option>
    ));

    return (
      <Dropdown
        value={this.state.value}
        onChange={this.onChange}
        className="native-lang-selector"
      >
        <option value={DEFAULT_OPTION}>{DEFAULT_OPTION}</option>
        {options}
      </Dropdown>
    );
  }
}
